import { BaseFieldView } from '../BaseField/views';

export const TextFieldView = BaseFieldView.extend({
    events: {
        'change textarea': 'save_value',
        'keyup textarea': 'expand_textarea'
    }
});
